// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#register-layout {\n  min-height: 100vh;\n}\n#register-layout > .ant-layout-content {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n#register-layout header {\n  height: 20px;\n  margin-top: 10px;\n  text-align: center;\n}\n#register-layout .register-form {\n  margin: 40px;\n  min-width: 300px;\n}\n#register-layout .ant-layout-content {\n  background: #fff;\n  border-radius: 7px;\n}\n", ""]);
// Exports
module.exports = exports;
